const footerCz = {
    "follow_us": "Sledujte nás!",
    "all_rights_reserved": "2024 Code Kitchen Kft všechna práva vyhrazena",
    "terms_and_conditions": "Obchodní podmínky",
    "privacy_policy": "Zásady ochrany osobních údajů"
};

export default footerCz;
